import { useLayoutEffect, useRef } from 'react';
import { railPreviewMaxHeight, railPreviewPosition } from './railGeometry';

export function useRailPreviewPosition(side: 'left' | 'right') {
  const preview = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const node = preview.current;
    const rail = node?.closest<HTMLElement>('.token-rail');
    if (!node || !rail) return;
    let frame = 0;
    const set = (property: string, value: string) => {
      if (node.style.getPropertyValue(property) !== value)
        node.style.setProperty(property, value);
    };
    const position = () => {
      const chip = rail.querySelector<HTMLElement>('.is-active .rail-chip');
      if (chip && node.getClientRects().length) {
        const bounds = rail.getBoundingClientRect();
        const css = getComputedStyle(node);
        const scale = Number.parseFloat(css.scale) || 1;
        const maxHeight = railPreviewMaxHeight(
          bounds,
          window.innerHeight,
          scale,
        );
        set('max-height', maxHeight + 'px');
        set('visibility', maxHeight > 2 ? 'visible' : 'hidden');
        const position = railPreviewPosition(
          side,
          bounds,
          chip.getBoundingClientRect(),
          node.getBoundingClientRect().height / scale,
          scale,
          window.innerHeight,
        );
        set(side, position.inset + 'px');
        set('top', position.top + 'px');
        set('--preview-bridge-width', 12 / scale + 2 + 'px');
      }
      // Follow hover, arrival, list movement and preview scale on the same frame.
      // Only a mounted (open) preview runs this loop, and unchanged styles aren't written.
      frame = requestAnimationFrame(position);
    };
    position();
    return () => cancelAnimationFrame(frame);
  }, [side]);
  return preview;
}
